import { render, staticRenderFns } from "./NotificationSummary.vue?vue&type=template&id=32b3f713&scoped=true"
import script from "./NotificationSummary.vue?vue&type=script&lang=ts"
export * from "./NotificationSummary.vue?vue&type=script&lang=ts"
import style0 from "./NotificationSummary.vue?vue&type=style&index=0&id=32b3f713&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b3f713",
  null
  
)

export default component.exports